import { CreatePatientMutation, GetLocationQuery } from '@/API';
import { createPatient } from '@/graphql/mutations';
import { getLocation } from '@/graphql/queries';
import { GraphQLQuery } from '@aws-amplify/api';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { generateClient } from 'aws-amplify/api';
import {
  FetchUserAttributesOutput,
  fetchUserAttributes,
} from 'aws-amplify/auth';
import { databaseMigrationAdapter } from '@/services/DatabaseMigrationAdapter'; // Updated import

const client = generateClient();

const useCreatePatient = () => {
  const userSelector = (context: { user: any }) => [context.user]; // Keep any for compatibility
  const { user } = useAuthenticator(userSelector);

  const handleCreatePatient = async (
    patientName: string,
    patientClient: string,
  ) => {
    console.log('[REACT-HOOK] Starting patient creation process');

    const userInfo: FetchUserAttributesOutput = await fetchUserAttributes();
    const locationData = await client.graphql<GraphQLQuery<GetLocationQuery>>({
      query: getLocation,
      variables: { id: userInfo['custom:location'] },
    });
    const location = locationData.data.getLocation;

    const newPatient = {
      name: patientName,
      client: patientClient,
      image: 'pet-image-placeholder.png',
      owners: [user.username],
    };
    if (userInfo) {
      newPatient['lID'] = userInfo['custom:location'];
      if (location && location.groupUsers) {
        newPatient['groups'] = [location.groupUsers, location.groupAdmins];
      }
    }

    console.log('[REACT-HOOK] Calling Amplify createPatient GraphQL mutation');
    const addPatientResult = await client.graphql<
      GraphQLQuery<CreatePatientMutation>
    >({ query: createPatient, variables: { input: newPatient } });

            console.log('[REACT-HOOK] Amplify patient creation successful, calling database migration service');
    // Call database migration service for logging and dual-write
    await databaseMigrationAdapter.handlePatientOperation('CREATE', newPatient, addPatientResult as unknown as Record<string, unknown>);

    return addPatientResult;
  };

  return { handleCreatePatient };
};

export default useCreatePatient;
